import "tom-select/dist/css/tom-select.css";
import TomSelect from "tom-select";

function isDarkMode() {
  return document.documentElement.classList.contains("dark");
}

// Función para aplicar estilos personalizados de Flowbite
function applyFlowbiteStyles() {
  const style = document.createElement("style");
  style.textContent = `
    /* Estilos para el control principal */
    .ts-control {
      background: rgb(249 250 251) !important;
      border: 1px solid rgb(209 213 219) !important;
      border-radius: 0.5rem !important;
      padding: 0.625rem !important;
      font-size: 0.875rem !important;
      line-height: 1.25rem !important;
      color: rgb(17 24 39) !important;
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
      transition: all 0.15s ease-in-out !important;
      min-height: 42px !important;
    }

    .ts-control:focus-within {
      outline: 2px solid transparent !important;
      outline-offset: 2px !important;
      border-color: rgb(59 130 246) !important;
      box-shadow: 0 0 0 3px rgb(59 130 246 / 0.1) !important;
    }

    /* Estilos para modo oscuro del control */
    .dark .ts-control {
      background: rgb(55 65 81) !important;
      border-color: rgb(75 85 99) !important;
      color: rgb(255 255 255) !important;
    }

    .dark .ts-control:focus-within {
      border-color: rgb(59 130 246) !important;
      box-shadow: 0 0 0 3px rgb(59 130 246 / 0.1) !important;
    }

    /* Placeholder */
    .ts-control .ts-placeholder {
      color: rgb(156 163 175) !important;
      font-size: 0.875rem !important;
    }

    .dark .ts-control .ts-placeholder {
      color: rgb(156 163 175) !important;
    }

    /* Estilos para items seleccionados */
    .ts-control .item {
      background: rgb(59 130 246) !important;
      color: white !important;
      border: none !important;
      border-radius: 0.375rem !important;
      padding: 0.25rem 0.5rem !important;
      font-size: 0.75rem !important;
      margin: 0.125rem !important;
      display: inline-flex !important;
      align-items: center !important;
    }

    .dark .ts-control .item {
      background: rgb(59 130 246) !important;
    }

    /* Botón de eliminar en items */
    .ts-control .item .remove {
      color: rgba(255, 255, 255, 0.8) !important;
      margin-left: 0.25rem !important;
      font-size: 1rem !important;
      border: none !important;
      background: none !important;
      cursor: pointer !important;
    }

    .ts-control .item .remove:hover {
      color: white !important;
      background: rgba(0, 0, 0, 0.1) !important;
      border-radius: 50% !important;
    }

    /* Dropdown */
    .ts-dropdown {
      background: white !important;
      border: 1px solid rgb(209 213 219) !important;
      border-radius: 0.5rem !important;
      box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -2px rgb(0 0 0 / 0.05) !important;
      margin-top: 0.25rem !important;
      z-index: 9999 !important;
    }

    .dark .ts-dropdown {
      background: rgb(55 65 81) !important;
      border-color: rgb(75 85 99) !important;
    }

    /* Opciones del dropdown */
    .ts-dropdown .option {
      padding: 0.75rem !important;
      font-size: 0.875rem !important;
      color: rgb(17 24 39) !important;
      cursor: pointer !important;
      transition: all 0.15s ease-in-out !important;
      border-bottom: 1px solid rgb(243 244 246) !important;
    }

    .ts-dropdown .option:last-child {
      border-bottom: none !important;
    }

    .ts-dropdown .option:hover,
    .ts-dropdown .option.active {
      background: rgb(239 246 255) !important;
      color: rgb(59 130 246) !important;
    }

    .dark .ts-dropdown .option {
      color: rgb(229 231 235) !important;
      border-bottom-color: rgb(75 85 99) !important;
    }

    .dark .ts-dropdown .option:hover,
    .dark .ts-dropdown .option.active {
      background: rgb(75 85 99) !important;
      color: rgb(147 197 253) !important;
    }

    /* No results */
    .ts-dropdown .no-results {
      padding: 0.75rem !important;
      color: rgb(107 114 128) !important;
      font-size: 0.875rem !important;
      text-align: center !important;
    }

    .dark .ts-dropdown .no-results {
      color: rgb(156 163 175) !important;
    }

    /* Input de búsqueda */
    .ts-control input {
      border: none !important;
      outline: none !important;
      background: transparent !important;
      color: inherit !important;
      font-size: 0.875rem !important;
    }

    /* Flecha del dropdown */
    .ts-control .ts-dropdown-arrow {
      width: 20px !important;
      height: 20px !important;
      margin-right: 0.5rem !important;
    }

    .ts-control .ts-dropdown-arrow svg {
      width: 16px !important;
      height: 16px !important;
      color: rgb(107 114 128) !important;
    }

    .dark .ts-control .ts-dropdown-arrow svg {
      color: rgb(156 163 175) !important;
    }

    /* Animaciones */
    .ts-dropdown {
      animation: dropdown-in 0.15s ease-out !important;
    }

    @keyframes dropdown-in {
      from {
        opacity: 0;
        transform: translateY(-0.5rem) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    /* Estados de carga */
    .ts-dropdown .loading {
      padding: 0.75rem !important;
      text-align: center !important;
      color: rgb(107 114 128) !important;
      font-size: 0.875rem !important;
    }

    .dark .ts-dropdown .loading {
      color: rgb(156 163 175) !important;
    }
  `;
  document.head.appendChild(style);
}

document.addEventListener("DOMContentLoaded", function () {
  // Aplicar estilos personalizados
  applyFlowbiteStyles();

  const docenteSelect = document.getElementById("docente_id");

  if (docenteSelect) {
    const tomSelect = new TomSelect(docenteSelect, {
      create: false,
      placeholder: "Escribe para buscar docente...",
      maxOptions: 50,
      loadThrottle: 500,
      preload: false,
      openOnFocus: false,
      searchField: ["text"],

      // Configuración para búsqueda AJAX
      load: function (query, callback) {
        if (query.length < 2) {
          callback();
          return;
        }

        const url = `/admin/dashboard/search-docentes?q=${encodeURIComponent(
          query
        )}`;

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            callback(data);
          })
          .catch((error) => {
            console.error("Error al buscar docentes:", error);
            callback();
          });
      },

      // Renderizado personalizado mejorado
      render: {
        option: function (data, escape) {
          return `
            <div class="option-item">
              <div class="font-medium">${escape(data.text)}</div>
            </div>
          `;
        },

        item: function (data, escape) {
          return `<div>${escape(data.text)}</div>`;
        },

        no_results: function (data, escape) {
          return `
            <div class="no-results">
              No se encontraron docentes para "${escape(data.input)}"
            </div>
          `;
        },

        loading: function (data, escape) {
          return `
            <div class="loading">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Buscando...
            </div>
          `;
        },
      },

      // Configuraciones adicionales
      hideSelected: true,
      allowEmptyOption: false,
      selectOnTab: true,
      closeAfterSelect: true,
    });

    // Manejar el cambio de tema oscuro/claro
    const observer = new MutationObserver(() => {
      // El CSS ya maneja los cambios de tema automáticamente
      // Solo necesitamos forzar un re-render si es necesario
      setTimeout(() => {
        const control = document.querySelector(".ts-control");
        if (control) {
          control.style.display = "none";
          control.offsetHeight; // Fuerza un repaint
          control.style.display = "";
        }
      }, 10);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Evento personalizado para cuando cambie el tema
    document.addEventListener("dark-mode", () => {
      // Los estilos CSS ya se actualizan automáticamente
    });
  }
});
